import React from 'react';

import { DocumentStatus, Maybe } from '@/globalTypes';

export function getDocumentStatusLabel(status: Maybe<DocumentStatus>) {
  if (!status) {
    return null;
  }

  return (
    <>
      {status === DocumentStatus.Verified && '✅ '}
      {status === DocumentStatus.Rejected && '❌ '}
      {status === DocumentStatus.Pending && '⏳ '}
      {status === DocumentStatus.NotUploaded && '📂 '}
      {status}
    </>
  );
}
